import { createRouter, createWebHistory } from 'vue-router'

import { isAuthenticated } from '@/libs/auth'
import { useAppStore } from '@/stores/app'

const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) return savedPosition
        if (from.path === to.path) return {}

        return { top: 0, behavior: 'smooth' }
    },
    routes: [
        {
            path:     '/',
            redirect: '/dashboard',
        },
        {
            path:      '/login',
            name:      'login',
            component: () => import('@/views/Login.vue'),
            meta:      { layout: 'Blank', requiresAuth: false },
        },
        {
            path:      '/change-password',
            name:      'change-password',
            component: () => import('@/views/ChangePassword.vue'),
            meta:      { requiresAuth: true },
        },
        {
            path:      '/dashboard',
            name:      'dashboard',
            component: () => import('@/views/Dashboard.vue'),
            meta:      { requiresAuth: true },
        },
        {
            path:      '/themes',
            name:      'themes',
            component: () => import('@/views/theme/Themes.vue'),
            meta:      { requiresAuth: true },
        },
        {
            path:      '/menu',
            name:      'menu',
            component: () => import('@/views/menu/MenuTree.vue'),
            meta:      { requiresAuth: true },
        },
        {
            path:      '/models',
            name:      'models',
            component: () => import('@/views/model/Models.vue'),
            meta:      { requiresAuth: true },
        },
        {
            path:      '/number-rules',
            name:      'number-rules',
            component: () => import('@/views/numberrule/NumberRules.vue'),
            meta:      { requiresAuth: true },
        },
        {
            path:      '/phone-number-limits',
            name:      'phone-number-limits',
            component: () => import('@/views/numberlimit/PhoneNumberLimits.vue'),
            meta:      { requiresAuth: true },
        },
        {
            path:      '/sessions',
            name:      'sessions',
            component: () => import('@/views/session/Sessions.vue'),
            meta:      { requiresAuth: true },
        },
        {
            path:      '/sessions/:id',
            name:      'session',
            component: () => import('@/views/session/Session.vue'),
            meta:      { requiresAuth: true },
        },
        {
            path:      '/users',
            name:      'users',
            component: () => import('@/views/user/Users.vue'),
            meta:      { requiresAuth: true },
        },
        {
            path:      '/settings',
            name:      'settings',
            component: () => import('@/views/Settings.vue'),
            meta:      { requiresAuth: true },
        },
        {
            path:      '/audit-log',
            name:      'audit-log',
            component: () => import('@/views/audit/AuditLog.vue'),
            meta:      { requiresAuth: true },
        },
    ],
})

router.beforeEach(async (to) => {
    const appStore = useAppStore()

    if (!isAuthenticated()) {
        if (to.meta.requiresAuth) {
            appStore.setLogout()

            return { name: 'login' }
        }

        return true
    }

    const loaded = await appStore.ensureUserLoaded()
    if (!loaded) {
        appStore.setLogout()

        return { name: 'login' }
    }

    // A freshly created operator can reach nothing but the password form. The API
    // enforces the same rule; this only keeps the UI from showing dead ends.
    if (appStore.mustChangePassword && to.name !== 'change-password') {
        return { name: 'change-password' }
    }

    if (to.name === 'login') {
        return { name: 'dashboard' }
    }

    return true
})

export default router
